/**
 * Continuous position watch. High-accuracy, no cache, and **unfiltered** — every fix is
 * forwarded, including poor ones (REQ-GPS-1/2): filtering in the field is irreversible,
 * filtering in analysis is not. Errors are reported but never stop the watch (REQ-GPS-4):
 * a run with no GPS is degraded, a run that will not start is lost.
 *
 * The `Geolocation` is injected so this tests without a browser (REQ-NFR-4).
 */
export function watchPosition(
  geo: Geolocation,
  onFix: (p: GeolocationPosition) => void,
  onError: (e: GeolocationPositionError) => void,
): () => void {
  const id = geo.watchPosition(onFix, onError, {
    enableHighAccuracy: true,
    maximumAge: 0,
    timeout: 30_000,
  });
  return () => geo.clearWatch(id);
}
